import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@api/core';
import { Patient, PatientBasicData, PersonListResponse, PersonType, emailDto } from './patient.model';
import { map } from 'rxjs/operators';
import { LoginResponse, UserApiService } from '@api/user';
import { DocumentFile } from '../../app/helpers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environment/environment';

const API_URL = 'person';
const API_LIST_URL = 'persons';
const API_AVATAR = 'person_avatar';


@Injectable()
export class PatientApiService {

  constructor(private api: ApiService, private user: UserApiService, private httpClient: HttpClient) { }

  private getUrl(api: string, path: string = ''): string {
    return `${environment.api[api]}${path}`;
  }

  public getBasicAuth(): string {
    return environment.basicAuth;
  }

  private getTimezoneHeaderByMultipart(): HttpHeaders {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const login_response: LoginResponse= JSON.parse(sessionStorage.getItem('login_response'));

    return new HttpHeaders({
      'X-Timezone': timeZone,
      'X-Account-Id': login_response.userDetails.id_account.toString(),
      'X-User-Email': login_response.userDetails.username,
      'X-Professional-Id': login_response.userDetails.id_person.toString(),
      // No se necesita agregar Content-Type explícitamente aquí
      // Ya que Angular lo maneja automáticamente con FormData
    });
  }

  all(personType: PersonType, instituteId: string, page: String = "0", size: String = "6", search: string = "", personSegmentCode: string = "", lastMedicalConsultationDate: moment.Moment = null): Observable<any> {
    let searchBy = "";
    if (search != "")
      searchBy = "&searchBy=" + search;
    let personSegment = "";
    if (personSegmentCode != "")
      personSegment = "&personSegmentCode=" + personSegmentCode;
    let lastMedicalConsultation = "";
    if (lastMedicalConsultationDate)
      lastMedicalConsultation = "&optionalLastMedicalConsultation=" + lastMedicalConsultationDate.format("YYYY-MM-DD");
    return this.api.get<any>(API_LIST_URL, `/pagesPerson?accountId=${instituteId}&persontype=${personType}&size=${size}&page=${page}
            ${searchBy}${personSegment}${lastMedicalConsultation}`).pipe(map(data => {
      return data;
    }));
  }

  getEvaluatedPersons(segementId: number, accountIs: number, fromDate: string, toDate: string): Observable<any> {


    return this.api.get<any>(API_LIST_URL, `/segments/${segementId}/evaluated-persons?accountId=${accountIs}&fromDate=${fromDate}&toDate=${toDate}`);
  }

  get(id: string): Observable<Patient> {
    return this.api.get(API_URL, '/' + id);
  }

  add(patient: Patient): Observable<Patient> {
    return this.api.post(API_URL, '?accountId=' + this.user.getUser().instituteId, patient);
  }

  update(patientId: number, patient: Patient) {
    return this.api.put(API_URL, '/' + patientId, patient);
  }

  getImage(patientId: number): Observable<DocumentFile> {
    return this.api.get<DocumentFile>(API_AVATAR, `/image?patientId=${patientId}`);
  }

  uploadImage(formData: FormData): Observable<string> {

    const headers = this.getTimezoneHeaderByMultipart();
    const options = { headers }; // Crear objeto de opciones con los encabezados

    return this.httpClient.post<string>(this.getUrl(API_AVATAR), formData, options);
  }

  updateBasicData(patientId: number, data: PatientBasicData): Observable<any> {
    return this.api.put(API_LIST_URL, `/${patientId}/basicData`, data);
  }

  updateEmailPerson(personId: number, accountId: number, email: emailDto): Observable<any> {
    return this.api.put(API_LIST_URL, `/${personId}/email?accountId=${accountId}`, email)
  }

  getNutricionist(instituteId: number, page: number = 0, size: number = 6): Observable<PersonListResponse> {
    return this.api.get<any>(API_LIST_URL, `/nutritionists?accountId=${instituteId}&size=${size}&page=${page}`);
  }


}

